function setBaseUrl(url) {
	let last_char = url.substr(url.length - 1);

	if (last_char == '/') {
		return url.substring(0, url.length - 1);
	}

	return url;
}